import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { fadeUp, viewportOnce } from "../lib/motion";

const HowClosing = () => (
    <section
        data-testid="hiw-closing"
        className="relative overflow-hidden bg-abyss py-28 lg:py-36"
    >
        <div className="relative mx-auto max-w-[1600px] px-6 md:px-10 lg:px-16">
            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
            >
                <p className="font-mono text-[13px] tracking-[0.3em] text-mist">
                    READY?
                </p>
                <h2 className="mt-8 max-w-3xl font-display text-4xl font-semibold leading-[1.1] text-white md:text-6xl">
                    Your plans are the beginning
                    <span className="text-accent">.</span>
                </h2>
                <p className="mt-6 max-w-xl text-[16px] leading-relaxed text-mist">
                    Bring what you have — BuildEase helps you understand what
                    comes next.
                </p>
                <div className="mt-10 flex flex-wrap items-center gap-4">
                    <Link
                        to="/join-the-pilot"
                        data-testid="hiw-closing-get-started"
                        className="group inline-flex items-center gap-2 bg-accent px-7 py-4 text-[16px] font-semibold text-white transition-colors duration-300 hover:bg-[#ff7026]"
                    >
                        Get Started
                        <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5" />
                    </Link>
                    <Link
                        to="/sample-report"
                        data-testid="hiw-closing-sample-report"
                        className="inline-flex items-center gap-2 border border-white/25 px-7 py-4 text-[16px] font-medium text-white transition-colors duration-300 hover:border-accent"
                    >
                        See a Sample Report
                    </Link>
                </div>
            </motion.div>
        </div>
    </section>
);

export default HowClosing;
